import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GuiService } from './../../../app/services/gui.service';
import { NavigationItem } from 'src/@vex/interfaces/navigation-item.interface';
import { TranslateService } from '@ngx-translate/core';
import { Component, ElementRef, HostBinding, Input } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { ConfigService } from '../../config/config.service';
import { map, startWith, switchMap } from 'rxjs/operators';
import { NavigationService } from '../../services/navigation.service';
import { PopoverService } from '../../components/popover/popover.service';
import { MegaMenuComponent } from '../../components/mega-menu/mega-menu.component';
import { Observable, of } from 'rxjs';
import {RestService} from "../../../app/services/rest.service";
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'vex-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class ToolbarComponent {

  @Input() mobileQuery: boolean;

  @Input()
  @HostBinding('class.shadow-b')
  hasShadow: boolean;

  navigationItems: NavigationItem[] | any = this.navigationService.items;
  iconFlag: string

  notifications: any

  isHorizontalLayout$: Observable<boolean> = this.configService.config$.pipe(map(config => config.layout === 'horizontal'));
  isVerticalLayout$: Observable<boolean> = this.configService.config$.pipe(map(config => config.layout === 'vertical'));
  isNavbarInToolbar$: Observable<boolean> = this.configService.config$.pipe(map(config => config.navbar.position === 'in-toolbar'));
  isNavbarBelowToolbar$: Observable<boolean> = this.configService.config$.pipe(map(config => config.navbar.position === 'below-toolbar'));
  userVisible$: Observable<boolean> = this.configService.config$.pipe(map(config => config.toolbar.user.visible));

  megaMenuOpen$: Observable<boolean> = of(false);



  constructor(private layoutService: LayoutService,
              private configService: ConfigService,
              private navigationService: NavigationService,
              private popoverService: PopoverService,
              public translate: TranslateService,
              public GuiService: GuiService,
              public restSrv: RestService,
              public rotta: Router,
              public dialog: MatDialog,
              private fb: UntypedFormBuilder,
              public notificationService: NotificationService
              ) {
                translate.addLangs(['en', 'it']);
                translate.setDefaultLang('it');

                const browserLang = translate.getBrowserLang();
                translate.use(browserLang.match(/en|it/) ? browserLang : 'it');
                if(browserLang == 'it'){
                  this.iconFlag = 'flag:italy'
                }else{
                  this.iconFlag = 'flag:united-states'
                }
               }



  openQuickpanel(): void {
    this.layoutService.openQuickpanel();
  }

  openSidenav(): void {
    this.layoutService.openSidenav();
  }

  openMegaMenu(origin: ElementRef | HTMLElement): void {
    this.megaMenuOpen$ = of(
      this.popoverService.open({
        content: MegaMenuComponent,
        origin,
        offsetY: 12,
        position: [
          {
            originX: 'start',
            originY: 'bottom',
            overlayX: 'start',
            overlayY: 'top'
          },
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
          },
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  openSearch(): void {
    this.layoutService.openSearch();
  }



  changeLanguage(lang){
    this.GuiService.changeLang(lang)
    if(lang === 'en'){
      this.iconFlag = 'flag:united-states'
    }
    if(lang === 'it'){
      this.iconFlag = 'flag:italy'
    }
  }

  public get changeFlag(){
    return this.iconFlag
  }

  ngOnInit() {
  }

}
